import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import jsonServerProvider from './jsonProvider/digigemJsonProvider';
import { GET_MANY } from 'ra-core';
import { FUNCTION_URL, LOGOUT_URL } from './Constants/index';
import CryptoJS from 'crypto-js';

export default async (type, params) => {
    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
        let response = await fetch(FUNCTION_URL + '/ValidateToken', {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain',
                'x-zumo-auth': localStorage.getItem('auth-token')
            },
            body: {
                token: localStorage.getItem('auth-token')
            }
        })
            .catch(error => {
                console.log(error);
                return Promise.reject(error);
            });

        if (response.status === 200) {
            let result = await response.json();
            
            localStorage.setItem('auth-token', result.newToken);

            getNonRegmanNMUs();

            let setting = await fetch(FUNCTION_URL + '/settings/SAP_Offline', {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/plain',
                    'x-zumo-auth': localStorage.getItem('auth-token')
                }
            })
                .catch(error => {
                    console.log(error);
                    return Promise.reject(error);
                });
            if(setting.status === 200){
                  let setting_result = await setting.json() ;
                  localStorage.setItem('sap_off', setting_result.value.flag);
                  localStorage.setItem('sap_off_date', setting_result.value.start_date);
            }
            let userInfo = {
                data: result.doc
            };
            if (userInfo.data.login === null || userInfo.data.role === null) {
                return Promise.reject("Configurazione parametri utente obbligatori assenti");
            }
            if (userInfo.data.role === "approvatore" && userInfo.data.tipologia !== 'profilo_su_magazzino' && userInfo.data.aoa === null) {
                return Promise.reject("Configurazione parametri utente obbligatori assenti");
            }
            localStorage.setItem('username',userInfo.data.user);

            var cod_terr_saps = undefined;

            if (userInfo.data.role === "magazziniere") {
                cod_terr_saps = await getUserImpresa(userInfo.data.company, userInfo.data.cod_terr_sap);
            }

            //Approvatore can see all Impresa
            if (userInfo.data.role === 'administrator'  || userInfo.data.role === 'dg') {
                localStorage.setItem('cod_terr_sap', '');
            } else if ( userInfo.data.role === 'approvatore'){
                const codList = userInfo.data.cod_terr_sap.split(',');
                localStorage.setItem('cod_terr_sap', JSON.stringify(codList));
            } else if ((cod_terr_saps && cod_terr_saps.length > 0)) {
                //save all the possible cod_terr_sap for that impresa for future use
                localStorage.setItem('impresa_cod_terr_sap', JSON.stringify(cod_terr_saps));
                
                let cod_terr_sap_limited = [];
                if(userInfo.data.cod_terr_sap && userInfo.data.cod_terr_sap !== ""){
                    //Make sure that we only use the cod_terr_sap that belongs to the provided company
                    userInfo.data.cod_terr_sap.split(',').forEach(item => {
                        if(cod_terr_saps.includes(item)){
                            cod_terr_sap_limited.push(item);
                        }
                    })

                    if(cod_terr_sap_limited.length !== 0) {
                        localStorage.setItem('cod_terr_sap', JSON.stringify(cod_terr_sap_limited));
                    }
                    else {
                        return Promise.reject("Configurazione parametri utente obbligatori assenti");
                    }
                }
                else {
                    localStorage.setItem('cod_terr_sap', JSON.stringify(cod_terr_saps));
                }
            }
            else {
                return Promise.reject("Configurazione parametri utente obbligatori assenti");
            }
            setData(userInfo);
            return Promise.resolve();
        }
        else if (response.status === 401) {
            const body = await response.json();
            const error = body.error;
            if (error === 'digigem.error.user.disabled') {
                return Promise.reject('Utente disabilitato');
            } else {
                return Promise.reject('Il token fornito non è valido o è scaduto');
            }
        }
        else {
            return Promise.reject('Si è verificato un errore nella convalida del token');
        }
    }
    //NOT USED ANYMORE called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('auth-token');
        localStorage.removeItem('uinf');
        localStorage.removeItem('username');
        document.location.href = LOGOUT_URL;
        return Promise.reject();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('auth-token');
            localStorage.removeItem('uinf');
            localStorage.removeItem('username');
            document.location.href = LOGOUT_URL;
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        return localStorage.getItem('auth-token')
            ? Promise.resolve()
            : Promise.reject();
    }
    if (type === AUTH_GET_PERMISSIONS) {
        var role = getData().data.role;
        return role ? Promise.resolve(role) : Promise.reject();
    }
    return Promise.reject('Unknown method');
};

function getUserImpresa(company, cod_terr_saps) {
    const dataProvider = jsonServerProvider(FUNCTION_URL);
    return dataProvider(GET_MANY, 'magmois', { "filter": { codice_impresa_sap: company } })
        .then(
            response => {
                var resp = [];
                for (var i in response.data) {
                    resp.push(response.data[i].cod_terr_sap);
                };
                return resp;
            })
        .catch(error => {
            console.log(error);
            return undefined;
        });
}

function setData(r) {
    var key = CryptoJS.AES.encrypt(JSON.stringify(r), localStorage.getItem('username')).toString();
    localStorage.setItem('uinf', key);
}
export function getData() {
    var bytes = CryptoJS.AES.decrypt(localStorage.getItem('uinf'), localStorage.getItem('username'));
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalText);
}

async function getNonRegmanNMUs() {
    const dataProvider = jsonServerProvider(FUNCTION_URL);
    let nonRegmanNomenclatores = await dataProvider(GET_MANY, 'nomenclatores', { "filter": { regman: { $in: false } } })
        .then(
            response => {
                return response.total ? response : undefined;
            })
        .catch(error => {
            console.log(error);
            return undefined;
        });

    let nonRegmanNMUs = [];
    if (nonRegmanNomenclatores && nonRegmanNomenclatores.total > 0) {
        
        nonRegmanNomenclatores.data.forEach(n => {
            nonRegmanNMUs.push(n.cod_nmu);
        })
        localStorage.setItem('nonRegmanNMUs', nonRegmanNMUs);
    }
}